let load = require('./helpers/browser/esm-js-loader-shards-super.js')(4);
module.exports = (load("f0x4d")).then(() => parcelRequire('fyPr9'));